import axios from "axios";
import { getSessionId } from "../../../../../utils/tokenHandlers";
import UidEmailRoleMatch from "../../../../constants/uidEmailRoleMatch";

export const getSendBackDocid = (appNumber: string) => {
  const sessionId = getSessionId();
  const UidEmailRole = UidEmailRoleMatch();

  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/read/many/ir.attachment`,
      {
        params: {
          ...UidEmailRole,
          filter: `[('name','=','Instruction_${appNumber}.pdf')]`,
          query: "{id}",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
